// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_s5-0";
export var checkoutRateBadgeLink = "_s5-1";